/**
 * @generated SignedSource<<641c4f8bb7690ba2e764969026901dfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GoogleCredentialsMutation$variables = {
  file: any;
};
export type GoogleCredentialsMutation$data = {
  readonly uploadGoogleCredentials: string | null;
};
export type GoogleCredentialsMutation = {
  response: GoogleCredentialsMutation$data;
  variables: GoogleCredentialsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "file"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "file",
        "variableName": "file"
      }
    ],
    "kind": "ScalarField",
    "name": "uploadGoogleCredentials",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GoogleCredentialsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoogleCredentialsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b013b36349edc7b430e8ce2687ea9f59",
    "id": null,
    "metadata": {},
    "name": "GoogleCredentialsMutation",
    "operationKind": "mutation",
    "text": "mutation GoogleCredentialsMutation(\n  $file: Upload!\n) {\n  uploadGoogleCredentials(file: $file)\n}\n"
  }
};
})();

(node as any).hash = "5fc3725cd5eadb64ff5071b7a27b46f7";

export default node;
